import { Disclosure } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/outline";

const faqs = [
  {
    question: "What form is created by using the REIT Public Form Wizard?",
    answer: "You are creating a REIT Lease Package, which contains: ",
    listItems: [
      "The latest version of the Residential Tenancy Agreement",
      "Condition Report",
      "The Rental Guide - Produced by Consumer, Building and Occupational Services (CBOS)",
    ],
  },
  {
    question: "Why should I purchase a REIT Lease Package?",
    answer:
      "The Residential Tenancy Agreement is a legally binding document between owner and tenant covering terms and conditions of a residential tenancy.  Our document is compliant with current Tasmanian Legislation and easy for each party to complete.",
    paragraphs: [
      "To be able to lodge a bond with MyBond you will be required to have completed an ingoing Condition Report at the start of the tenancy. To use our template, simply work through the condition report which has many of the items prefilled, saving you time.",
      "The Tasmanian Government provides a Rental Guide that is very helpful for owners and tenants. It is an easy to read guide to renting covering frequently asked questions and much more.",
    ],
  },
  {
    question: "Who is the REIT Public Form Wizard meant for?",
    answer:
      "The REIT Public Form Wizard is for anyone who needs to create a Residential Tenancy Agreement for a property located within Tasmania, for a one time fee.",
  },

  {
    question:
      "What if I've made a mistake while completing the forms but have already paid for it?",
    answer:
      <>Not a problem! Simply get in contact with the team at <a className="text-blue-600 underline" target="blank" rel="noreferrer" href='mailto:reit@reit.com.au'>reit@reit.com.au</a> and we'll resolve the issue.</>,
  },

  {
    question: "What if the property being leased is in a different state?",
    answer:
      <>If the property being rented is outside of Tasmania, please visit <a className="text-blue-600 underline" target="blank" rel="noreferrer" href='https://reia.com.au/contact-us/'>https://reia.com.au/contact-us/</a> for contact details of the relevant REI in each state.</>,
  },
  {
    question:
      "What do I do if the property being leased is in Tasmania but I need a different form?",
    answer:
    <>If you need a different form, please contact <a className="text-blue-600 underline" target="blank" rel="noreferrer" href='mailto:reit@reit.com.au'>reit@reit.com.au</a> to see a list of your options.</>,
  },
];

function classNames(...questions) {
  return questions.filter(Boolean).join(" ");
}

export default function FAQ() {
  return (
    <div className="bg-white min-h-[55vh]">
      <div className="max-w-7xl mx-auto py-12 px-4 sm:py-16 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto divide-y-2 divide-gray-200">
          <h2 className="text-center text-4xl mb-12 font-extrabold text-gray-700">
            Frequently Asked Questions
          </h2>
          <dl className="mt-6 space-y-6 divide-y divide-gray-200">
            {faqs.map((faq) => (
              <Disclosure as="div" key={faq.question} className="pt-6">
                {({ open }) => (
                  <>
                    <dt className="text-lg">
                      <Disclosure.Button className="text-left w-full flex justify-between items-start text-gray-400">
                        <span className="text-xl font-semibold text-gray-700">
                          {faq.question}
                        </span>
                        <span className="ml-6 h-7 flex items-center">
                          <ChevronDownIcon
                            className={classNames(
                              open ? "-rotate-180" : "rotate-0",
                              "h-6 w-6 transform"
                            )}
                            aria-hidden="true"
                          />
                        </span>
                      </Disclosure.Button>
                    </dt>
                    <Disclosure.Panel as="dd" className="mt-2 pr-12">
                      <p className="text-base text-gray-500">{faq.answer}</p>
                      {faq.paragraphs &&
                        faq.paragraphs.length &&
                        faq.paragraphs.map((paragraph) => {
                          return (
                              <p className="text-base text-gray-500 mt-2">
                                {paragraph}
                              </p>
                          );
                        })}
                      {faq.listItems &&
                        faq.listItems.length &&
                        faq.listItems.map((item) => {
                          return (
                            <ul>
                              <li className="text-base text-gray-500 list-disc ml-6">
                                {item}
                              </li>
                            </ul>
                          );
                        })}
                    </Disclosure.Panel>
                  </>
                )}
              </Disclosure>
            ))}
          </dl>
        </div>
      </div>
    </div>
  );
}
